<template>
  <div>
    <betriebsanweisungAction
      v-if="item._kind === 'created'"
      :item="item"
      :config="config"
      @reloadData="reload"
    />
    <operatingInstructionAction v-else :item="item" @reloadData="reload" />
  </div>
</template>

<script>
import betriebsanweisungAction from "./betriebsanweisungAction.vue";
import operatingInstructionAction from "./operatingInstructionAction.vue";

export default {
  name: "operatingInstructionRowAction",
  components: { betriebsanweisungAction, operatingInstructionAction },
  props: ["item", "config"],
  methods: {
    reload() {
      this.$emit("reloadData");
    },
  },
};
</script>
